import { render } from "./TeamsPage.vue?vue&type=template&id=27936950&ts=true"
import script from "./TeamsPage.vue?vue&type=script&lang=ts"
export * from "./TeamsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Admin/Teams/TeamsPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "27936950"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('27936950', __exports__)) {
    api.reload('27936950', __exports__)
  }
  
  module.hot.accept("./TeamsPage.vue?vue&type=template&id=27936950&ts=true", () => {
    api.rerender('27936950', render)
  })

}


export default __exports__